const NAMES = {
  citi: 'Citi Bank',
  chase: 'Chase Bank',
};

export default name =>
  NAMES[name.toLowerCase()] ? NAMES[name.toLowerCase()] : name;
